import { useEffect, useState } from "react";
import { getLocationApi, getOperationModel } from "../../../api/searchApi";
import { FALLBACK_INDUSTRY_CHOICES, FALLBACK_LOCATION_CHOICES, pickExtentChoices } from "../../../helper/extentChoices";

function useFilterChoices(token) {
  const [industryChoices, setIndustryChoices] = useState(FALLBACK_INDUSTRY_CHOICES);
  const [locationChoices, setLocationChoices] = useState(FALLBACK_LOCATION_CHOICES);
  useEffect(() => {
    let cancelled = false;
    getOperationModel()
      .then((response) => {
        if (!cancelled) {
          setIndustryChoices(pickExtentChoices(response, FALLBACK_INDUSTRY_CHOICES));
        }
      })
      .catch(() => {
        if (!cancelled) setIndustryChoices(FALLBACK_INDUSTRY_CHOICES);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  useEffect(() => {
    let cancelled = false;
    getLocationApi()
      .then((response) => {
        if (!cancelled) {
          setLocationChoices(pickExtentChoices(response, FALLBACK_LOCATION_CHOICES));
        }
      })
      .catch(() => {
        if (!cancelled) setLocationChoices(FALLBACK_LOCATION_CHOICES);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return { industryChoices, locationChoices };
}

export { useFilterChoices };
